import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: white;
  border-radius: 12px;
  width: 360px;
  padding: 3% 24px;
`;

const ModalTitle = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 32px;
`;

const ModalDescription = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 32px;
  color: #8E8E8E;
`;

const ButtonContainer = styled.div`
  margin-top: 15%;
  margin-bottom: -10%;
  display: flex;
  justify-content: center;
  gap: 8%;
`;

const Button = styled.button<{ primary?: boolean }>`
  width: 40%;
  padding: 12px 0;
  border-radius: 30px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  
  ${props => props.primary ? `
    background-color: #2282E9;
    color: white;
  ` : `
    background-color: #F1F1F1;
    color: #666666;
  `}
`;

interface ModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

export const CheckPageMoveModal = ({ onClose, onConfirm }: ModalProps) => {
  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalTitle>
          페이지를 이동하시겠습니까?
        </ModalTitle>
        <ModalDescription>
          해당 페이지의 내용이 일부 저장되지 않을 수 있습니다. <br />
          저장 후 페이지를 이동해주세요!
        </ModalDescription>
        <ButtonContainer>
          <Button onClick={onClose}>
            이동 취소
          </Button>
          <Button primary onClick={onConfirm}>
            저장 후 이동
          </Button>
        </ButtonContainer>
      </ModalContainer>
    </ModalOverlay>
  );
}; 